import React from "react";
import PropTypes from "prop-types";

const VariantBuilderSettingHtml = (props) => {
  return <React.Fragment>{props.children}</React.Fragment>;
};

export default VariantBuilderSettingHtml;
